import Dexie from "dexie";

const VERSION = "v1";
const DATABASE_NAME = "@destinyplumbing/definitions";

export const _Dexie = Dexie;

export const db = new Dexie(DATABASE_NAME);
db.version(1).stores({
  definitions: "&key, data"
});

async function fetchJson(...opts) {
  return (await fetch(...opts)).json();
}

function fetchBungie(url, apiKey) {
  console.log("fetch bungie", { url, apiKey });
  return fetchJson(url, {
    headers: {
      "X-API-Key": apiKey
    }
  });
}

function hasAllKeys(obj, keys) {
  for (let i = keys.length - 1; i >= 0; i--) {
    const key = keys[i];

    if (!obj[key]) {
      return false;
    }
  }

  return true;
}

function pruneTables(obj, keys) {
  if (!keys.length) {
    return obj;
  }

  return keys.reduce((acc, key) => {
    return {
      ...acc,
      [key]: obj[key]
    };
  }, {});
}

async function fetchDefinitionsPath(apiKey, language) {
  const manifest = await fetchBungie(
    "https://www.bungie.net/Platform/Destiny2/Manifest/",
    apiKey
  );

  return manifest.Response.jsonWorldContentPaths[language];
}

function cleanUpPreviousVersions(keyToKeep) {
  db.definitions
    .toCollection()
    .primaryKeys()
    .then(keys => {
      const toDelete = keys.filter(key => !key.includes(keyToKeep));
      return db.definitions.bulkDelete(toDelete);
    });
}

export async function staleThenRevalidate(
  apiKey,
  language,
  requestedTableNames,
  dataCb
) {
  const versionId = `${VERSION}:`;

  const allPreviousDefinitions = await db.definitions.toCollection().toArray();
  const earlyCache = allPreviousDefinitions.find(d => {
    return d.key.indexOf(versionId) === 0;
  });

  const hasAllTables =
    earlyCache && hasAllKeys(earlyCache.data, requestedTableNames);

  if (earlyCache) {
    const onlyRequestedTables = pruneTables(
      earlyCache.data,
      requestedTableNames
    );

    dataCb(null, { definitions: onlyRequestedTables, cached: true });
  }

  const definitionsPath = await fetchDefinitionsPath(apiKey, language);

  if (earlyCache && earlyCache.key.includes(definitionsPath) && hasAllTables) {
    // The cached definitions we returned previously are the current definitions, no need to continue
    dataCb(null, { finished: true });
    return;
  }

  dataCb(null, { loading: true });

  const freshDefinitions = await fetchJson(
    `https://www.bungie.net${definitionsPath}`
  );

  const onlyRequestedTables = pruneTables(
    freshDefinitions,
    requestedTableNames
  );

  dataCb(null, { definitions: onlyRequestedTables, finished: true });

  const versionKey = `${versionId}${definitionsPath}`;

  // Don't wait for (or fail on) 'background' db operations
  db.definitions.put({ key: versionKey, data: onlyRequestedTables });
  cleanUpPreviousVersions(definitionsPath, versionKey);
}



// WEBPACK FOOTER //
// ./node_modules/@destiny-plumbing/definitions/src/index.js